import React, { createContext, useContext, useState, useCallback } from 'react';

interface CmsPanelContextValue {
  isPanelOpen: boolean;
  panelContainer: HTMLDivElement | null;
  setPanelContainer: (el: HTMLDivElement | null) => void;
  openPanel: () => void;
  closePanel: () => void;
}

const CmsPanelContext = createContext<CmsPanelContextValue>({
  isPanelOpen: false,
  panelContainer: null,
  setPanelContainer: () => {},
  openPanel: () => {},
  closePanel: () => {},
});

export const useCmsPanel = () => useContext(CmsPanelContext);

export const CmsPanelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [panelContainer, setPanelContainer] = useState<HTMLDivElement | null>(null);

  const openPanel = useCallback(() => setIsPanelOpen(true), []);
  const closePanel = useCallback(() => setIsPanelOpen(false), []);

  return (
    <CmsPanelContext.Provider value={{ isPanelOpen, panelContainer, setPanelContainer, openPanel, closePanel }}>
      {children}
    </CmsPanelContext.Provider>
  );
};
